export default __webpack_public_path__ + "static/media/promote_1.9b35c324.png";